module.exports = __webpack_public_path__ + "static/img/Isaac_Heeney_desktop.2d90cca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Isaac_Heeney_desktop.jpg
// module id = GuP4
// module chunks = 0